import { render, staticRenderFns } from "./flag_demo.vue?vue&type=template&id=5828ecb2&scoped=true&"
import script from "./flag_demo.vue?vue&type=script&lang=js&"
export * from "./flag_demo.vue?vue&type=script&lang=js&"
import style0 from "./flag_demo.vue?vue&type=style&index=0&id=5828ecb2&lang=scss&scoped=true&"
import style1 from "./flag_demo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828ecb2",
  null
  
)

export default component.exports